<template>
  <common-panel :panel-data="panelData" @doBefore="doBefore" ref="commonPanel"></common-panel>
</template>

<script>
import CommonPanel from "../../common/panel/CommonPanel";

export default {
  name: "EnergyRealtime",
  components: {CommonPanel},
  data() {
    return {
      panelData: {
        hasTree: true,
        hasMenu: true,
        energyItem: [{'id': '1', 'name': '电'}, {'id': '2', 'name': '水'}, {'id': '11', 'name': '气'}, {'id': '12', 'name': '汽'}],
        treeProps: {
          children: 'childNode',
          label: 'name'
        },
        treeMethod: this.$api.systemManage.getSensorTree,
        treeValue: "1",
        queryMethod: this.$api.energyMonitor.getAllSensorParam,
        typeBack: 'changeable',
        beforeQueryTree: true,
        buttons: [],
        energyItemClick: this.selItem,
        filterForm: [
          {label: '表计名称：', prop: 'sensor_name', type: 'input', value: '', style: 'width: 140px;margin-right: 12px;'},
          {label: '', prop: 'typeId', type: 'radioExtra', value: '1', style: 'height: 100%;width: 100%;display: flex;flex-wrap: nowrap;overflow: auto hidden;',
            props: {value: 'typeId', label: 'typeName'},
            options: [],
            changeBack: this.selBack
          }
        ],
        methods: {
          excelAPI: '/params_query/sensorParam',
          query_id: 'id'
        },
        tableCheck: false,
        tableProp: [],
        tablePropsTemp: [
          {prop: "sensorName", label: "表名称"},
          {prop: "status", label: "表状态", width: 72, strList: ['离线', '在线']},
          {prop: "gatName", label: "通信单元"},
          {prop: "1", label: "A相电压(V)", show: false, showKey: '1'},
          {prop: "2", label: "B相电压(V)", show: false, showKey: '1'},
          {prop: "3", label: "C相电压(V)", show: false, showKey: '1'},
          {prop: "4", label: "A相电流(A)", show: false, showKey: '2'},
          {prop: "5", label: "B相电流(A)", show: false, showKey: '2'},
          {prop: "6", label: "C相电流(A)", show: false, showKey: '2'},
          {prop: "7", label: "三相电压不平衡度(标准值≤4)", show: false, showKey: '11'},
          {prop: "8", label: "三相电流不平衡度(标准值≤10)", show: false, showKey: '12'},
          {prop: "9", label: "A相功率因数", show: false, showKey: '6'},
          {prop: "10", label: "B相功率因数", show: false, showKey: '6'},
          {prop: "11", label: "C相功率因数", show: false, showKey: '6'},
          {prop: "12", label: "总功率因数(标准值≥0.9)", show: false, showKey: '6'},
          {prop: "13", label: "A相有功功率(kW)", show: false, showKey: '3'},
          {prop: "14", label: "B相有功功率(kW)", show: false, showKey: '3'},
          {prop: "15", label: "C相有功功率(kW)", show: false, showKey: '3'},
          {prop: "16", label: "总有功功率(kW)", show: false, showKey: '3'},
          {prop: "17", label: "A相无功功率(kVar)", show: false, showKey: '4'},
          {prop: "18", label: "B相无功功率(kVar)", show: false, showKey: '4'},
          {prop: "19", label: "C相无功功率(kVar)", show: false, showKey: '4'},
          {prop: "20", label: "总无功功率(kVar)", show: false, showKey: '4'},
          {prop: "21", label: "A相视在功率(kVA)", show: false, showKey: '5'},
          {prop: "22", label: "B相视在功率(kVA)", show: false, showKey: '5'},
          {prop: "23", label: "C相视在功率(kVA)", show: false, showKey: '5'},
          {prop: "24", label: "总视在功率(kVA)", show: false, showKey: '5'},
          {prop: "25", label: "当前总有功电能(kWh)", show: false, showKey: '7'},
          {prop: "26", label: "当前总无功电能(kVarh)", show: false, showKey: '7'},
          {prop: "27", label: "总尖有功电能(kWh)", show: false, showKey: '7'},
          {prop: "28", label: "总峰有功电能(kWh)", show: false, showKey: '7'},
          {prop: "29", label: "总谷有功电能(kWh)", show: false, showKey: '7'},
          {prop: "30", label: "总平有功电能(kWh)", show: false, showKey: '7'},
          {prop: "31", label: "正向有功电能(kWh)", show: false, showKey: '7'},
          {prop: "32", label: "反向有功电能(kWh)", show: false, showKey: '7'},
          {prop: "33", label: "正向有功需量(kW)", show: false, showKey: '9'},
          {prop: "34", label: "反向有功需量(kW)", show: false, showKey: '9'},
          {prop: "37", label: "A相电流THD", show: false, showKey: '13'},
          {prop: "38", label: "B相电流THD", show: false, showKey: '13'},
          {prop: "39", label: "C相电流THD", show: false, showKey: '13'},
          {prop: "40", label: "A相电压THD", show: false, showKey: '14'},
          {prop: "41", label: "B相电压THD", show: false, showKey: '14'},
          {prop: "42", label: "C相电压THD", show: false, showKey: '14'},
          {prop: "35", label: "频率(Hz)", show: false, showKey: '10'},
          {prop: "101", label: "水止码(m3)", show: false, showKey: '21'},
          {prop: "111", label: "气止码(m3)", show: false, showKey: '31'},
          {prop: "121", label: "热止码(m3)", show: false, showKey: '41'},
          {prop: "dataTime", label: "数据时间", width: 166}
        ]
      }
    }
  },
  created() {
  },
  methods: {
    doBefore(treeValue) {
      let selFilter = this.panelData.filterForm[1];
      this.$api.energyMonitor.getDataType('1').then(res => {
        selFilter.value = res.data[0].typeId;
        this.refreshTableProps(res.data[0].typeId);
        selFilter.options = res.data;
        this.$refs.commonPanel.getTree(treeValue);
      })
    },
    selBack(val) {
      this.refreshTableProps(val, false);
    },
    refreshTableProps(val, isCreate = true) {
      let tableProps = this.panelData.tablePropsTemp;
      tableProps.forEach(tp => {
        if(tp.hasOwnProperty('showKey')) {
          tp.show = tp.showKey === val;
        }
      });
      this.panelData.tableProps = tableProps;
      if(typeof this.panelData.typeBack === 'function' && !isCreate) this.panelData.typeBack();
    },
    selItem(val) {
      let selFilter = this.panelData.filterForm[1];
      this.$api.energyMonitor.getDataType(val).then(res => {
        selFilter.value = res.data[0].typeId;
        selFilter.options = res.data;
        this.refreshTableProps(res.data[0].typeId);
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/EnergyEfficiency/EnergyMonitor/EnergyRealtime.vue